import type { PeriodType } from '@/api/base/enums'
import type { Amount } from '@/types/interfaces'
import type { SearchFieldOption } from '@/types/modules/search'

export interface TeamUserFormOption {
  // 表单绑定的字段名
  value: string
  // 占据的行数
  span: number
  // 是否必填
  required: boolean
  // 表单校验信息
  message?: string
  // 是否隐藏label
  hideLabel?: boolean
  // 是否隐藏
  visible?: boolean
}

export type TeamUserFormOptions = TeamUserFormOption & SearchFieldOption

export interface SetGoalsData {
  // 周期类型
  type: PeriodType
  // 年份
  year: number | string
  // 目标金额
  price: Amount
  // 盈利金额
  profit: Amount
  // 用户ID
  userId?: string
  // 团队ID
  organizationId?: string
  // 用户名称
  userName?: string
}

// 公告阅读记录结构体
export interface NoticeReadOptions {
  // 是否已读
  read: boolean
  // 确认时间
  confirmTime: number
}

// 公告阅读状态开关
export enum NoticeReadStatus {
  // 开启
  OPEN = '1',
  // 关闭
  CLOSE = '2',
}
